<!-- 成色判定 -->
<template>
    <h2 style="color: #fff">成色判定</h2>
    <!-- <span style="color: #fff">#todo:【未实现】 注意每个菜单栏有联动关系</span><br />
    <span style="color: #fff">#todo:【未实现】 筛选项采用模糊搜索,快速定位</span><br /> -->

    <!-- 筛选菜单栏 -->
    <div>
        <el-form :inline="true" :model="formConditionSelectData">
            <!-- 选择平台 -->
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.sources" clearable placeholder="选择平台" @change="platformChange">
                    <el-option v-for="item in sourcesList" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>

            <!-- 选择瑕疵项 -->
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.descLevel1" filterable remote clearable placeholder="选择瑕疵项">
                    <el-option v-for="item in descLevel1List" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <!-- 选择瑕疵值 -->
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.descLevel2" clearable filterable remote placeholder="选择瑕疵值">
                    <el-option v-for="item in descLevel2List" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <!-- 选择平台 -->
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.sources" clearable placeholder="选择类型" @change="platformChange">
                    <el-option v-for="item in sourcesList" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <!-- 选择判定成色 -->
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.condition" clearable placeholder="选择外观成色">
                    <el-option v-for="item in conditionList" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="formConditionSelectData.condition" clearable placeholder="选择功能成色">
                    <el-option v-for="item in conditionList" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <br />
            <!-- 按钮 -->
            <el-form-item>
                <el-button type="primary" @click="getconditioncheckList()">查询</el-button>
                <el-button type="primary" @click="clearselect()">全部清除</el-button>
            </el-form-item>
        </el-form>
    </div>
    <!-- 数据展示 -->
    <el-table :data="conditionCheckList" border>
        <!-- id -->
        <el-table-column label="表id" v-if="false" min-width="200px">
            <template #default="scope">
                {{ scope.row.id }}
            </template>
        </el-table-column>

        <!-- 前端编号 -->
        <el-table-column label="序号" width="55px">
            <template #default="scope">
                {{ scope.$index + 1 }}
            </template>
        </el-table-column>

        <!-- 平台 -->
        <el-table-column label="平台" width="120px">
            <template #default="scope">
                {{ scope.row.sources }}
            </template>
        </el-table-column>
        <!-- 瑕疵项 -->
        <el-table-column label="瑕疵项" width="300px">
            <template #default="scope">
                {{ scope.row.descLevel1 }}
            </template>
        </el-table-column>
        <!-- 瑕疵值 -->
        <el-table-column label="瑕疵值" min-width="300px">
            <template #default="scope">
                {{ scope.row.descLevel2 }}
            </template>
        </el-table-column>
        <!-- 转转预估类型 -->
        <el-table-column label="类型" width="100">
            <template #default="scope"> 功能情况 </template>
        </el-table-column>
        <!-- 成色判定 -->
        <el-table-column label="外观成色" min-width="50px">
            <template #default="scope">
                <el-select v-if="scope.row.editable" v-model="scope.row.condition" placeholder="选择判定成色">
                    <el-option v-for="item in conditionList" :key="item" :label="item" :value="item" />
                </el-select>
                <span v-else>{{ scope.row.condition }}</span>
            </template>
        </el-table-column>
        <el-table-column label="功能成色" min-width="50px">
            <template #default="scope">
                <el-select v-if="scope.row.editable" v-model="scope.row.condition" placeholder="选择判定成色">
                    <el-option v-for="item in conditionList" :key="item" :label="item" :value="item" />
                </el-select>
                <span v-else>{{ scope.row.condition }}</span>
            </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" header-align="center" align="center" min-width="100px">
            <template v-slot="scope">
                <!-- 添加判定 -->
                <el-button type="warning" @click="showConditionEditDialog(scope.row)" v-if="!scope.row.condition"> 添加判定 </el-button>
                <!-- 更新判定 -->
                <div v-if="scope.row.condition">
                    <div v-if="scope.row.editable">
                        <el-button type="warning" @click="sendconditionCheck(scope.row, scope.$index)"> 提交修改 </el-button>
                        <el-button type="info" @click="cancelShowConditionEditDialog(scope.row, scope.$index)"> 取消修改 </el-button>
                    </div>
                    <div v-else>
                        <!-- 修改 -->
                        <el-button type="success" @click="showConditionEditDialog(scope.row)"> 修改 </el-button>
                        <!-- 删除 -->
                        <el-button type="danger" @click="handleconditionCheckDelete(scope.row)"> 删除 </el-button>
                    </div>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <!-- 页码栏 -->
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allchecks">
    </el-pagination>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import { scrollToTop } from "@/utils/utils";
    import brandcheckView from "@/views/autoprice/setting/brandcheckView.vue";
    import conditioncheckView from "@/views/autoprice/setting/conditioncheckView.vue";
    import damagecheckView from "@/views/autoprice/setting/damagecheckView.vue";
    import modelcheckView from "@/views/autoprice/setting/modelcheckView.vue";
    import redpacketView from "@/views/autoprice/setting/redpacketView.vue";
    import axios from "axios";

    export default {
        name: "PracticalTableView",
        components: {
            FixedButtons,
            redpacketView,
            brandcheckView,
            modelcheckView,
            damagecheckView,
            conditioncheckView,
        },
        data() {
            return {
                wwq: "",
                // 筛选栏平台品牌
                sourcesList: [],
                // 筛选栏瑕疵项
                descLevel1List: [],
                // 筛选栏瑕疵值
                descLevel2List: [],
                // 筛选栏成色判定
                conditionList: [],

                props: { multiple: true, label: "paramValue", value: "看后端传来的" },

                // 获取表格数据
                getconditioncheckListURL: "/api/PlatformDesc/conditionConfigQueryDataByParam",
                // 下拉框初始化
                menuselectInitURL: "/api/PlatformDesc/conditionConfigurationInit",
                // 修改成色判定
                conditionUpdateURL: "/api/PlatformDesc/update",
                // 删除成色判定
                conditionDelURL: "/api/PlatformDesc/delete",

                // 当前页码
                pageNo: 1,
                // 总数
                allchecks: 0,
                // 每页显示条目数
                pageSize: 20,

                BrandReflectShow: true,
                modelReflectShow: false,
                damageReflectShow: false,

                // 平台瑕疵项
                platformDesc: null,

                // 筛选条件
                formConditionSelectData: {
                    // // 平台
                    // sources: "",
                    // // 瑕疵项
                    // descLevel1: "",
                    // // 瑕疵值
                    // descLevel2: "",
                    // // 判定成色
                    // condition: "",
                },

                adddescLevel2List: [], // 添加时候的系统品牌
                //新增编辑弹框
                isConditionDialogVisible: false,
                // brandId: '', //新增id
                // productBrandId: '', //新增品牌id
                brandMappingmName: "",
                currentBrandMapping: {
                    editId: undefined,
                    id: "",
                    productBrandId: "",
                    brandName: "",
                },

                // 成色判定列表
                conditionMappingList: [],

                formData: {
                    brandId: "", //系统品牌id
                    otherModelName: "", // 其他平台型号
                    productModelName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },

                conditionCheckList: [], // 平台信息
                correspondenceList: [], // 对应信息
                syslevel1List: [], //系统平台品牌
                sysPlatformModelList: [], //系统平台型号
                otherPlatformModelList: [], // 其他平台型号
                sources: "", //平台
                brandId: "",
                isBrandId: "", //系统平台品牌是否映射过
                isBrandName: "",
                isDialogVisible: false, //新增编辑弹框
                sysModelList: [], // 系统标准型号列表
                otherPlatformName: "",
                currentMapping: {
                    editId: undefined,
                    id: "",
                    brandId: "",
                    productModelId: "",
                    modelName: "",
                    editProductModelId: "",
                },

                formFlawData: {
                    descLevel1: "", //一级瑕疵
                    descLevel2: "", // 二级瑕疵
                    standardsKeyWord: "", // 系统瑕疵
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                flawDataList: [], // 瑕疵映射列表
                flawOneLevelList: [], //一级瑕疵
                flawTwoLevelList: [], //二级瑕疵
                sysStandardFlawListOne: [], //系统一级瑕疵数据
                sysStandardFlawListTwo: [], //系统二级瑕疵数据
                sysStandardFlawListThree: [], //系统三级瑕疵数据
                isFlawDialogVisible: false, //瑕疵弹框
                currentFlawMapping: {
                    editId: undefined,
                    id: "",
                    sdandardsLevel1: "", //一级名字
                    sdandardsLevel2: "", //二级名字
                    sdandardsLevel3: "", //三级名字
                    otherPlatformDescId: "",
                    pjtDescId: "",
                },
                otherPlatformNameFlaw: "",

                rules: {
                    modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
                },
            };
        },
        methods: {
            // 删除成色判定
            handleconditionCheckDelete(row) {
                try {
                    this.$confirm("确认删除当前映射吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.conditionDelURL + `?idList=${row.id}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.getconditioncheckList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },

            // 成色判定可编辑
            showConditionEditDialog(row) {
                row.editable = true;
                this.platformDesc = row;
            },
            cancelShowConditionEditDialog(row) {
                row.editable = false;
                this.platformDesc = row;
            },

            // 发送修改结果
            sendconditionCheck(row, index) {
                row.editable = false;
                axios
                    .put(
                        this.conditionUpdateURL,
                        {
                            id: row.id,
                            sources: row.sources,
                            descLevel1: row.descLevel1,
                            descLevel2: row.descLevel2,
                            condition: row.condition,
                        },
                        {
                            headers: {
                                satoken: localStorage.sa,
                            },
                        }
                    )
                    .then((response) => {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.getconditioncheckList();
                    })
                    .catch((error) => {
                        console.error("Error updating:", error);
                    });
            },

            // 清除选择条件
            clearselect() {
                if ("是点击的清空按钮,那么全部重置") {
                    this.formConditionSelectData = {
                        // // 平台
                        // sources: "",
                        // // 瑕疵项
                        // descLevel1: "",
                        // // 瑕疵值
                        // descLevel2: "",
                        // // 判定成色
                        // condition: "",
                    };
                    this.getconditioncheckList();
                } else {
                }
            },

            //平台改变
            platformChange() {
                this.getmenuInit();
            },

            // 菜单栏初始化
            getmenuInit() {
                axios
                    .get(this.menuselectInitURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.formConditionSelectData.sources,
                        },
                    })
                    .then((res) => {
                        if (this.formConditionSelectData.sources) {
                            this.descLevel1List = res.data.data.descLevel1List;
                            this.descLevel2List = res.data.data.descLevel2List;
                        } else {
                            this.sourcesList = res.data.data.sourcesList;
                            this.conditionList = res.data.data.conditionList;
                            this.descLevel1List = res.data.data.descLevel1List;
                            this.descLevel2List = res.data.data.descLevel2List;
                        }
                        // this.sourcesList = res.data.data.sourcesList;
                        // this.descLevel1List = res.data.data.descLevel1List;
                        // this.descLevel2List = res.data.data.descLevel2List;
                        // this.conditionList = res.data.data.conditionList;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询成色判定列表
            getconditioncheckList() {
                axios
                    .get(this.getconditioncheckListURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.pageNo,
                            pageSize: this.pageSize,
                            ...this.formConditionSelectData,
                        },
                    })
                    .then((res) => {
                        this.conditionCheckList = res.data.data.result;
                        this.pageNo = res.data.data.pageNo;
                        this.allchecks = res.data.data.total;
                        this.totalPages = res.data.data.totalPages;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 初始化页面
            nowtabInit() {
                this.nickName = localStorage.getItem("nickname") || "";
                this.phone = localStorage.getItem("tel") || "";
                // 初始化下拉框
                this.getmenuInit();

                // 初始化表格数据
                this.getconditioncheckList();
            },

            // 页面顶部
            _scrollToTop() {
                scrollToTop(this.$refs.scrollableDiv);
            },

            // 新增保存and编辑保存
            saveBrandMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentBrandMapping.editId === undefined) {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .post(this.addBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isConditionDialogVisible = false;
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .put(this.editBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isConditionDialogVisible = false;
                                        this.currentBrandMapping.productBrandId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },

            // 查询
            searchModelManager() {
                this.getCorrespondenceList();
            },

            // 来源变化
            sourcesChange(val) {
                this.getPlatformModelMapping(val);
            },

            change(val) {},

            //根据系统品牌查系统型号
            brandChange(val) {
                this.getSyspStandardModel(val);
            },

            // 查询平台和机型映射初始化下拉框
            getPlatformModelMapping(val) {
                axios
                    .get(this.platformModelMapping, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerModelPage,
                            sources: val,
                        },
                    })
                    .then((res) => {
                        this.otherPlatformModelList = res.data.data.otherPlatformNameList;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询系统标准的品牌和机型初始化下拉框
            getSyspStandardModel(val) {
                axios
                    .get(this.syspStandardModel, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerModelPage,
                            brandId: val ? val : this.isBrandId,
                        },
                    })
                    .then((res) => {
                        if (val) {
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        } else {
                            this.syslevel1List = res.data.data.brandIdAndNameList;
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 新增型号映射关系
            showAddDialog(row) {
                this.isDialogVisible = true;
                this.isBrandId = row.brandId;
                this.isBrandName = row.brandName;
                this.otherPlatformName = row.otherPlatformName;
                this.currentMapping.id = row.id;
                this.currentMapping.brandId = "";
                this.currentMapping.productModelId = "";
                this.getSyspStandardModel();
            },

            // 编辑型号映射
            showEditDialog(row) {
                this.isDialogVisible = true;
                this.isBrandId = row.brandId;
                this.isBrandName = row.brandName;
                this.otherPlatformName = row.otherPlatformName;
                this.currentMapping.productModelId = row.productModelName;
                this.currentMapping.editId = row.id;
                this.currentMapping.id = row.id;
                this.currentMapping.editProductModelId = row.id;
                this.currentMapping.modelName = row.modelName;
                this.getSyspStandardModel();
            },

            remoteMethod(query) {
                if (query !== "") {
                    // this.getSysModel(query);
                }
            },

            selectChange(val) {
                this.currentMapping.productModelId = val;
            },

            // 新增保存and编辑保存
            saveMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentMapping.editId === undefined) {
                            const body = {
                                id: this.currentMapping.id,
                                productModelId: this.currentMapping.productModelId,
                            };
                            axios
                                .post(this.addMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isDialogVisible = false;
                                        this.getCorrespondenceList();
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = {
                                id: this.currentMapping.id,
                                productModelId: this.currentMapping.productModelId,
                            };
                            axios
                                .put(this.editMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isDialogVisible = false;
                                        this.getCorrespondenceList();
                                        this.currentMapping.productModelId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },

            // 删除映射型号
            handleMappingDelete(row) {
                try {
                    this.$confirm("确认删除当前映射吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.deleteMapping + `?idList=${row.id}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.getCorrespondenceList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },

            // 型号映射关系列表
            getCorrespondenceList() {
                axios
                    .get(this.correspondence, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            ...this.formData,
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerModelPage,
                        },
                    })
                    .then((res) => {
                        this.allPagesmodel = res.data.data.total;
                        this.correspondenceList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 型号映射逻辑结束

            // 瑕疵映射逻辑开始
            // 查询
            searchFlawManager() {
                this.getFlawDataList();
            },

            // 根据平台去查
            sourcesChangeSelect(val) {
                this.formFlawData.sources = val;
                this.getFlawSearchList();
            },

            // 根据一级瑕疵去查
            flawChangeSelect(val) {
                this.formFlawData.descLevel1 = val;
                this.getFlawSearchList();
            },

            // 查询瑕疵列表
            getFlawDataList() {
                axios
                    .get(this.flawData, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            ...this.formFlawData,
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerFlawPage,
                        },
                    })
                    .then((res) => {
                        this.flawDataList = res.data.data.result;
                        this.allPagesFlaw = res.data.data.total;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询下拉检索数据
            getFlawSearchList() {
                axios
                    .get(this.flawSearch, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerFlawPage,
                            sources: this.formFlawData.sources,
                            descLevel1: this.formFlawData.descLevel1,
                            descLevel2: this.formFlawData.descLevel2,
                        },
                    })
                    .then((res) => {
                        if (this.formFlawData.descLevel1) {
                            this.flawTwoLevelList = res.data.data.descLevel2List;
                        } else {
                            this.flawOneLevelList = res.data.data.descLevel1List;
                            this.flawTwoLevelList = res.data.data.descLevel2List;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询pjt一二三级瑕疵数据
            getSysStandardFlawList() {
                axios
                    .get(this.sysStandardFlaw, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerFlawPage,
                            sdandardsLevel1: this.currentFlawMapping.sdandardsLevel1,
                            sdandardsLevel2: this.currentFlawMapping.sdandardsLevel2,
                        },
                    })
                    .then((res) => {
                        if (!this.currentFlawMapping.sdandardsLevel1 && !this.currentFlawMapping.sdandardsLevel2) {
                            this.sysStandardFlawListOne = res.data.data.sdandardsLevel1List;
                            this.sysStandardFlawListTwo = res.data.data.sdandardsLevel2List;
                            this.sysStandardFlawListThree = res.data.data.sdandardsLevel3VOList;
                        } else if (this.currentFlawMapping.sdandardsLevel1 && !this.currentFlawMapping.sdandardsLevel2) {
                            this.sysStandardFlawListTwo = res.data.data.sdandardsLevel2List;
                        } else {
                            this.sysStandardFlawListThree = res.data.data.sdandardsLevel3VOList;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            selectOneChange(val) {
                this.currentFlawMapping.sdandardsLevel1 = val;
                this.getSysStandardFlawList();
            },

            selectTwoChange(val) {
                this.currentFlawMapping.sdandardsLevel2 = val;
                this.getSysStandardFlawList();
            },

            selectThreeChange(val) {
                this.getSysStandardFlawList(val);
                this.currentFlawMapping.pjtDescId = val;
            },

            // 改变条数
            handleSizeChange(val) {
                this.pageSize = val;
                this.getconditioncheckList();
            },

            //改变页数
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getconditioncheckList();
            },
        },
        created() {},
        watch: {},
        computed: {},
        mounted() {},
    };
</script>

<style lang="scss" scoped></style>
